import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'service-video',
  templateUrl: './service-video.component.html',
  styleUrls: ['./service-video.component.sass']
})
export class ServiceVideoComponent implements OnInit {
  @Input() name: string;
  
  constructor() { }

  ngOnInit() {
  }

}
